import { Divider, Stack } from "@mui/material"
import type { FormTab } from "@pharmupp/p3-front-commons"
import type { PatientServiceFormValues } from "../SubFormComponents/PatientServices/PatientServices.schema"
import {
  Management,
  type ManagementFormValues,
  managementSchema,
} from "./Management"
import { PatientServices, patientServicesSchema } from "./PatientServices"

export const practicalInfo = managementSchema.concat(patientServicesSchema)

export type PracticalInfoFormValues = ManagementFormValues & PatientServiceFormValues

const PracticalInfoTabContent = () => (
  <Stack divider={<Divider flexItem />}>
    <Management />
    <PatientServices />
  </Stack>
)

export const practicalInfoTabs: FormTab[] = [
  {
    label: "Gestion de l'officine",
    to: ".",
    Element: PracticalInfoTabContent,
    schema: practicalInfo,
  },
]
